import composer, { type optionPairType } from "./composer";

export default (option: optionPairType) =>
  composer(option, "checkbox", {
    fieldLabel: "Must require a record for single-on condition",
    fieldValue: "",
  });
